import { data } from '../../svg/Code/data';
import { makeIcon } from '../makeIcon';

export const Code = makeIcon(data, 'code', 'Code');

export default Code;
